import { useDrag } from 'react-dnd'

const style = {
  position: 'relative',
  left: '30px',
  cursor: 'move'
}
const DraggableBlock = ({ block, category }) => {
  const [{ opacity }, drag] = useDrag(
    () => ({
      type: 'Block',
      item: { id: block.id, type: block.type, category },
      collect: monitor => ({
        opacity: monitor.isDragging() ? 0.4 : 1
      })
    }),
    [block.name]
  )
  return (
    <div ref={drag} role="Block" style={{ ...style, opacity }}>
      {block.name}
    </div>
  )
}

export default DraggableBlock
